import { render, staticRenderFns } from "./Datahub.vue?vue&type=template&id=9d38ab72"
import script from "./Datahub.vue?vue&type=script&lang=js"
export * from "./Datahub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports